import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../core/guards/auth.guard';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { ProfileEditComponent } from './profile-edit/profile-edit.component'
import { ProfileResolverService } from './profile-resolver.service';

const routes: Routes = [{
    path: 'profil',
    canActivate: [
        AuthGuard
    ],
    children: [
        {
            path: 'zmien-haslo',
            component: PasswordChangeComponent,
            data: {
                pageTitle: 'Zmień hasło'
            },
            resolve: {
                profile: ProfileResolverService
            }
        },
        {
            path: 'edytuj-profil',
            component: ProfileEditComponent,
            data: {
                pageTitle: 'Zmień hasło'
            },
            resolve: {
                profile: ProfileResolverService
            }
        }
    ]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProfileRoutingModule {
}
